import React from 'react'
import {Route, Switch} from 'react-router-dom'
import {SchedulingIndex} from './screens'

function SchedulingRoutes() {
  return (
    <Switch>
      <Route component={SchedulingIndex} />
    </Switch>
  )
}

export {SchedulingRoutes}
